import { Injectable } from '@angular/core';
import { NewrelicEvent, QPNewrelicService } from 'qp-newrelic';
import { ErrorInfo, ErrorSeverityType } from 'qp-store';
import { v4 as uuid } from 'uuid';
import { StoreService } from '../store/store.service';
import { ErrorCodeTranslationService } from 'src/app/shared/services/errorcode-translation/errorcode-translation.service';
import { NewrelicError } from '../enums/errors';
import { getPlayerErrorInfo } from 'src/app/shared/utils/playerUtils';
import { Error as FoundationError } from 'fl-foundation';

declare const newrelic: any;
declare const window: Window &
  typeof globalThis & {
    startTime: number;
  };

@Injectable({
  providedIn: 'root',
})
export class NewrelicService extends QPNewrelicService {
  constructor(readonly storeService: StoreService, private errorCodeService: ErrorCodeTranslationService) {
    // Last attribute is for showing NR logs
    super(storeService, newrelic, false);
  }

  public getTimeSinceLoadInfo(): { timeSinceLoad: number } {
    const timeNow = new Date().getTime();
    return {
      timeSinceLoad: window.startTime ? timeNow - window.startTime : 0,
    };
  }

  // Update timeSinceLoad and eventUUID before sending new event
  public sendEvent(eventName: NewrelicEvent): void {
    this.store.setEventInfo({
      appName: 'UNow',
      eventUUID: uuid(),
      ...this.getTimeSinceLoadInfo(),
    });
    return super.sendEvent(eventName);
  }

  public async sendError(
    errorEvent: NewrelicError,
    error: FoundationError,
    ec: number,
    em: string,
    errorSeverity?: ErrorSeverityType
  ): Promise<void> {
    try {
      const errorDescription = (await this.errorCodeService.getErrorByCode(ec?.toString(), em)).message;
      const { errorCode, errorMessage } = getPlayerErrorInfo(error);
      this.sendErrorEvent(errorEvent, errorCode, errorMessage, errorDescription?.replace(/<br>/g, '\n'), error, errorSeverity);
    } catch {}
  }

  sendErrorEvent(
    errorType: NewrelicError,
    errorCode: number | string,
    errorMessage: string,
    errorDescription: string,
    error: any,
    errorSeverity?: ErrorSeverityType,
    overrideAttributes?: any,
    internalError?: string
  ): void {
    const errorAttributes = this.getEventAttributes(NewrelicEvent.ERROR);
    const errorInfo: ErrorInfo = {
      ...errorAttributes,
      ...(overrideAttributes || {}),
      errorCode: errorCode.toString(),
      errorDescription,
      errorMessage,
      errorType,
      internalError,
      errorInternal: error,
      errorSeverity,
      eventUUID: uuid(),
    };
    this.sendBySDK(NewrelicEvent.ERROR, errorInfo);
  }
}
